<template>
  <transition-group name="fade" tag="div" class="notification-container">
    <div
      v-for="notification in notifications"
      :key="notification.id"
      :class="[
        'notification',
        `notification-${notification.type}`,
        { 'with-tailwind': useTailwind }
      ]"
    >
      <div class="notification-icon">
        <img
          :src="getIconSrc(notification.type)"
          :alt="notification.type"
          :class="['w-6 h-6', { 'animate-spin': notification.type === 'loading' }]"
        />
      </div>
      <div class="notification-content">
        {{ notification.message }}
      </div>
      <button v-if="notification.closable" @click="closeNotification(notification.id)" class="close-button">
        <img :src="closeIconSrc" alt="close" class="w-5 h-5" />
      </button>
    </div>
  </transition-group>
</template>

<script>
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'GlobalNotification',
  props: {
    useTailwind: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      notifications: [],
      icons: {
        info: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAxMGE4IDggMCAxMS0xNiAwIDggOCAwIDAxMTYgMHptLTctNGExIDEgMCAxMS0yIDAgMSAxIDAgMDEyIDB6TTkgOWEuNzUuNzUgMCAwMDAgMS41aC4yNTNhLjI1LjI1IDAgMDEuMjQ0LjMwNGwtLjQ1OSAyLjA2NkExLjc1IDEuNzUgMCAwMDEwLjc0NyAxNUgxMWEuNzUuNzUgMCAwMDAtMS41aC0uMjUzYS4yNS4yNSAwIDAxLS4yNDQtLjMwNGwuNDU5LTIuMDY2QTEuNzUgMS43NSAwIDAwOS4yNTMgOUg5eiIgY2xpcC1ydWxlPSJldmVub2RkIiAvPjwvc3ZnPg==',
        action: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS4zMTIgMTEuNDI0YTUuNSA1LjUgMCAwMS05LjIwMSAyLjQ2NmwtLjMxMi0uMzExaDIuNDMzYS43NS43NSAwIDAwMC0xLjVIMy45ODlhLjc1Ljc1IDAgMDAtLjc1Ljc1djQuMjQyYS43NS43NSAwIDAwMS41IDB2LTIuNDNsLjMxLjMxYTcgNyAwIDAwMTEuNzEyLTMuMTM4Ljc1Ljc1IDAgMDAtMS40NDktLjM5em0xLjIzLTMuNzIzYS43NS43NSAwIDAwLjIxOS0uNTNWMi45MjlhLjc1Ljc1IDAgMDAtMS41IDBWNS4zNmwtLjMxLS4zMUE3IDcgMCAwMDMuMjM5IDguMTg4YS43NS43NSAwIDEwMS40NDguMzg5QTUuNSA1LjUgMCAwMTEzLjg5IDYuMTFsLjMxMS4zMWgtMi40MzJhLjc1Ljc1IDAgMDAwIDEuNWg0LjI0M2EuNzUuNzUgMCAwMC41My0uMjE5eiIgY2xpcC1ydWxlPSJldmVub2RkIiAvPjwvc3ZnPg==',
        error: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAxMGE4IDggMCAxMS0xNiAwIDggOCAwIDAxMTYgMHptLTgtNWEuNzUuNzUgMCAwMS43NS43NXY0LjVhLjc1Ljc1IDAgMDEtMS41IDB2LTQuNUEuNzUuNzUgMCAwMTEwIDV6bTAgMTBhMSAxIDAgMTAwLTIgMSAxIDAgMDAwIDJ6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIC8+PC9zdmc+',
        loading: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYW5pbWF0ZS1zcGluIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS4zMTIgMTEuNDI0YTUuNSA1LjUgMCAwMS05LjIwMSAyLjQ2NmwtLjMxMi0uMzExaDIuNDMzYS43NS43NSAwIDAwMC0xLjVIMy45ODlhLjc1Ljc1IDAgMDAtLjc1Ljc1djQuMjQyYS43NS43NSAwIDAwMS41IDB2LTIuNDNsLjMxLjMxYTcgNyAwIDAwMTEuNzEyLTMuMTM4Ljc1Ljc1IDAgMDAtMS40NDktLjM5em0xLjIzLTMuNzIzYS43NS43NSAwIDAwLjIxOS0uNTNWMi45MjlhLjc1Ljc1IDAgMDAtMS41IDBWNS4zNmwtLjMxLS4zMUE3IDcgMCAwMDMuMjM5IDguMTg4YS43NS43NSAwIDEwMS40NDguMzg5QTUuNSA1LjUgMCAwMTEzLjg5IDYuMTFsLjMxMS4zMWgtMi40MzJhLjc1Ljc1IDAgMDAwIDEuNWg0LjI0M2EuNzUuNzUgMCAwMC41My0uMjE5eiIgY2xpcC1ydWxlPSJldmVub2RkIiAvPjwvc3ZnPg=='
      },
      closeIconSrc: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNNi4yOCA1LjIyYS43NS43NSAwIDAwLTEuMDYgMS4wNkw4Ljk0IDEwbC0zLjcyIDMuNzJhLjc1Ljc1IDAgMTAxLjA2IDEuMDZMMTAgMTEuMDZsMy43MiAzLjcyYS43NS43NSAwIDEwMS4wNi0xLjA2TDExLjA2IDEwbDMuNzItMy43MmEuNzUuNzUgMCAwMC0xLjA2LTEuMDZMMTAgOC45NCA2LjI4IDUuMjJ6IiAvPjwvc3ZnPg=='
    }
  },
  created() {
    EventBus.$on('show-notification', this.showNotification)
    EventBus.$on('close-notification', this.closeNotification)
  },
  beforeDestroy() {
    EventBus.$off('show-notification', this.showNotification)
    EventBus.$off('close-notification', this.closeNotification)
  },
  methods: {
    showNotification({ type, message, duration = 3000, closable = true }) {
      const id = Date.now()
      this.notifications.push({ id, type, message, closable })
      if (type !== 'loading' && duration > 0) {
        setTimeout(() => this.closeNotification(id), duration)
      }
      EventBus.$emit('notification-shown', id);
      return id;
    },
    closeNotification(id) {
      this.notifications = this.notifications.filter(n => n.id !== id)
    },
    getIconSrc(type) {
      return this.icons[type] || this.icons.info
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-container {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 45%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.notification {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  width: 100%;
}

.notification-icon {
  margin-right: 12px;
}

.notification-content {
  flex-grow: 1;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 4px;
}

.notification-info {
  background-color: #e3f2fd;
  color: #0d47a1;
}

.notification-action {
  background-color: #e8f5e9;
  color: #1b5e20;
}

.notification-error {
  background-color: #ffebee;
  color: #b71c1c;
}

.notification-loading {
  background-color: #fff3e0;
  color: #e65100;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) translateX(-50%);
}
.w-6{
  width: 1.5rem;
}
.h-6{
  height: 1.5rem;
}
/* Tailwind classes */
.with-tailwind {
  display: flex;
  align-items: center;
  padding: 0.75rem; // p-3
  margin-bottom: 0.75rem; // mb-3
  border-radius: 0.25rem; // rounded
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); // shadow-md
  max-width: 20rem; // max-w-xs
  width: 100%; // w-full

  &.notification-info {
    background-color: #dbeafe; // bg-blue-100
    color: #1e3a8a; // text-blue-900
  }

  &.notification-action {
    background-color: #dcfce7; // bg-green-100
    color: #14532d; // text-green-900
  }

  &.notification-error {
    background-color: #fee2e2; // bg-red-100
    color: #7f1d1d; // text-red-900
  }

  &.notification-loading {
    background-color: #ffedd5; // bg-orange-100
    color: #7c2d12; // text-orange-900
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
